import { CloudDownload } from '@mui/icons-material';
import { Button, Card, Grid } from '@mui/material';
import { useTracking } from 'react-tracking';
import { backgroundImage, downloadRequest, staticFile } from '../../services/utils';
import Hide from '../Hide/Hide';
import Show from '../Show/Show';
import styles from './PosterTile.module.scss';

interface PosterTileProps {
    poster: any,
}

export default function PosterTile(props: PosterTileProps) {

    const { trackEvent } = useTracking()

    const { poster } = props
    const imgStyle = { backgroundImage: backgroundImage(poster.cover) }

    const handleDownloadSpec = () => {
        trackEvent({ action: "downloadPdf", data: { "poster": poster.id } })
        downloadRequest(staticFile(poster.specifications), `fabric_${poster.reference}_specs.pdf`)
    }

    return (
        <Card className={styles.PosterTile}>
            <div className={styles.PosterTilePhoto} style={imgStyle}></div>

            <Grid container direction="column" justifyContent="space-between" className={styles.ContentWrapper}>

                <div className={styles.FabricType}>
                    {poster?.type !== 'FINISHING' ? <p>{poster?.fabricType?.name}</p> : <p>{poster?.name}</p>}
                    {poster?.type !== 'FINISHING' ? <p>{poster?.composition?.name}</p> : <p>{poster?.fabricType?.name}</p>}
                    <Show on={poster?.type !== 'FINISHING'}>
                        <p>{poster?.weight} gr/m²</p>
                        <p>{poster?.width} cm</p>
                    </Show>
                    <p className={styles.Story}>{poster.story}</p>
                </div>

                <Grid container className={styles.Footer} justifyContent="space-between" alignItems="center">
                    <p className={styles.Reference}>
                        <Hide on={poster?.type === 'FINISHING'}>
                            {poster.reference}
                        </Hide>
                    </p>
                    <p>
                        <Button variant="text" startIcon={<CloudDownload />} onClick={handleDownloadSpec}>
                            PDF
                        </Button>
                    </p>
                </Grid>
            </Grid>
        </Card>
    )
}
